import styled, { css } from 'styled-components'
import theme from 'theme_'
import { Font14, Font16, Secondary } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout'

export const NetworkStatusClientsContainer = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  width: 100%;
  background-color: ${theme.colors.lighterGrey};
  margin-right: 10px;
`

export const NetworkStatusClientsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const NetworkStatusClientsHeaderTitle = styled(Secondary)`
  display: flex;
  flex-direction: row;
  color: ${theme.colors.otterWarmBlack};
  ${Font16};
  font-weight: 900;
`

export const NetworkStatusClientsBody = styled.div`
  display: flex;
  gap: ${theme.spacing.base};
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`

const NetworkStatusClientsItemBase = css`
  width: 100%;
`

export const NetworkStatusClientsItem = styled.div<{
  disabled?: boolean
}>`
  justify-content: start;
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  ${NetworkStatusClientsItemBase};
  padding: ${theme.spacing.base};
  gap: ${theme.spacing.base};
  color: ${(p) => p.disabled && theme.colors.darkeyGrey};

  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`

export const NetworkStatusClientsItemHeader = styled.div`
  font-weight: 900;
`

export const NetworkStatusClientsCount = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  color: ${theme.colors.otterWarmBlack};
  font-size: 40px;
  font-weight: 900;
`

export const NetworkStatusClientsCountLabel = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  margin-top: 15px;
  color: ${theme.colors.moreGrey};
  ${Font16};
`

export const NetworkStatusClientsItemFooter = styled.div`
  ${Font14};
  display: flex;
  justify-content: flex-end;
  font-weight: 900;
`

export const NetworkStatusClientsForwardButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
  float: right;
`
